// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"1b4e6ddc","467":"7c9050fb","514":"5ce257bb","949":"7192272e"}[chunkId] + ".chunk.js";
};